import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.div`
    ${({ theme, displayState }) => {
    return css`
            color: white;     
            background: ${theme?.colour?.primary ?? '#1DBD6B'};
            font-size: 12px;
            text-align: center;
            padding: 0.1em 0.5em;
            border-radius: 4px;
    `}
  }`;


export default Atom({ type: 'label', dataType: 'string', template })
